import React from 'react';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-responsive-ui/style.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as envKeys from '../../../ENV';
import { getAllAffiliateLinkAction } from '../../../Actions/actions';
import BannerHead from '../../BannerHead';

class RegistrationLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      registrationLinks: [],
    };
  }

  componentDidMount() {
    const data = {
      userId: localStorage.getItem('userId'),
    };
    this.props.getAllAffiliateLinkAction(data);
  }

  componentWillReceiveProps(nextProps) {
    const setRegistrationLinksForUser = nextProps.data.setRegistrationLinksForUser;
    if (typeof setRegistrationLinksForUser !== 'undefined') {
      this.setState({
        registrationLinks: setRegistrationLinksForUser,
      });
    }
  }

  render() {
    const { registrationLinks } = this.state;
    // console.log(registrationLinks);
    const frontendUrl = envKeys.REACT_APP_FRONTEND_URL;

    return (
      <span>
        <div className="section-content support landing-urls dashboard">
          <div className="row">
            <div className="dashboard-tabs">
              <div className="row ">
                <BannerHead title="Resources" />

                {/* <div className="dashboard-bg settlement-dashboardbg">
                  <div className="col s12">
                    <h3>Resources</h3>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col s12">
              <div className="row">
                <div className="col s12 m12">
                  <h5>Registration Links</h5>
                  {typeof registrationLinks !== 'undefined' ? (
                    <div>
                      {registrationLinks.length > 0 ? (
                        <div>
                          {registrationLinks.map((link, idx) => (
                            <div>
                              <div
                                className="landing-link"
                                key={idx.toString()}
                              >
                                <div className="col s10">
                                  {frontendUrl}
                                  /signup/
                                  {link.affiliateKey}
                                  <div className="div-full landing-btns">
                                    <CopyToClipboard
                                      className="waves-light btn btn-blue save-changes"
                                      text={
                                        `${frontendUrl
                                        }/signup/${
                                          link.affiliateKey}`
                                      }
                                      onCopy={() =>
                                        this.setState({ copied: true })
                                      }
                                    >
                                      <button className="waves-light btn btn-blue save-changes">Copy Url</button>
                                    </CopyToClipboard>
                                    <a
                                      className="open-url-btn waves-light btn btn-blue save-changes"
                                      href={
                                        `${frontendUrl
                                        }/signup/${
                                          link.affiliateKey}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Open Url
                                    </a>
                                  </div>
                                </div>
                                <div className="landing-count-dash">
                                  <i className="material-icons">person</i>
                                  <span>{link.registeredUser}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div>No active links</div>
                      )}
                    </div>
                  ) : (
                    <div>No active links</div>
                  )}

                  {/* {(registrationLinks)? (
                                        <div>ddddd
                                            {(registrationLinks.map((link,idx) => {
                                                <div key={idx}>
                                                    Key {link.affiliateKey}
                                                </div>

                                            }))}
                                        </div>

                                    ): (
                                        <div>No date</div>
                                    )
                                    } */}
                </div>
              </div>
              <div className="row ">
                <div className="col s12 m12">
                  <div className="landing-outer">
                    <div className="col s12 m12">
                      <h5>Guides and Promotional Materials</h5>
                      <p>
                          The communication assets below have been created to
                          assist with promoting awareness and elevate
                          filing participation with our partners.
                      </p>
                    </div>
                    <div className="col s4">
                      <div className="landing-formats">
                        <h6>File Formats</h6>
                        <p>
                          We've provided standard file formats for download. All
                          creative work is available in native Adobe authoring
                          formats.
                          {' '}
                        </p>
                      </div>

                      <div className="landing-formats">
                        <h6>Print Files</h6>
                        <p>
                          Print files are provided in Illustrator CS6, PDF and
                          .EPS formats.
                          {' '}
                        </p>
                      </div>

                      <div className="landing-formats">
                        <h6>Web Graphics</h6>
                        <p>
                          All web files are provided in output formats as .PNG.
                          GIF or .JPEG.
                        </p>
                      </div>

                      <div className="landing-formats">
                        <h6>HTML Email </h6>
                        <p>
                          Files are prepared with in-line CSS and absolute
                          links. Please note that HTML email files are prepared
                          for use with HTML email applications like MailChimp or
                          Sales Force email sender.
                          {' '}
                        </p>
                      </div>

                      <div className="landing-formats">
                        <h6>Text & Copy</h6>
                        <p>
                          Text and copy are provided in MS Word and PDF formats.
                        </p>
                      </div>
                    </div>
                    <div className="col s8">
                      <div className="landing-rt">
                        <div className="landing-program">
                          <h5>Email & Portal Examples</h5>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/sample-email-template/">
                            {' '}
                            <i className="tiny material-icons">
                              arrow_forward
                            </i>
                            {' '}
                            Sample Customer Email - Introduces customers to the
                            Collectively filing option
                          </a>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/portal-content-example/">
                            {' '}
                            <i className="tiny material-icons">
                              arrow_forward
                            </i>
                            {' '}
                            Sample Intake Portal - Where customers enroll with
                            Collectively
                          </a>
                        </div>

                        <div className="landing-communication">
                          <h5>Communications Assets</h5>
                          <p>
                            The ready-to-use assets below make it easy to
                            provide effective communication to customers. Copy
                            reflects our understanding of what is both accurate
                            and legally compliant. When using these materials,
                            partners should validate that messaging fits their
                            needs and legal requirements.
                            {' '}
                          </p>
                          <p>
                            <b>
                            Any and all communications to customers regarding the settlement and filing must be approved by Collectively.
                            </b>
                            {' '}
                            The settlement administrator requires that certain
                            language is included on all communications and that
                            there is no misleading information.
                          </p>
                        </div>

                        <div className="landing-communication">
                          <h5>HTML Emails Files & Copy</h5>
                          <ul>
                            <li>
                              <h6>Introduction Email</h6>
                              <p>
                                These are individually prepared provided by
                                Collectively for each ISO.
                              </p>
                              <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/sample-email-template/">
                                <i className="tiny material-icons">arrow_forward</i>
                                {' '}
                                Example
                              </a>
                            </li>
                            <li>
                              <h6>Follow up Email</h6>
                              <p>
                                The brief message reiterates the value in filing
                                for customers.
                              </p>
                              <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/follow-up-email-example/">
                                <i className="small material-icons">
                                  picture_as_pdf
                                </i>
                              </a>
                            </li>
                            <li>
                              <h6>Filing Deadline Email</h6>
                              <p>
                                This copy outlines filing deadlines options for
                                customers.
                              </p>
                              <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/filing-deadline-example/">
                                <i className="small material-icons">
                                  picture_as_pdf
                                </i>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="landing-program">
                          <h5>VMC Icon Package</h5>
                          <p>
                            The VMC icon package contains a comprehensive set of
                            graphic file
                          </p>
                          <ul>
                            <h6>Package includes: </h6>
                            <li>- CMYK Illustrator file</li>
                            <li>- RGB Photoshop files</li>
                            <li>
                              - Sized outputs for GIF, .Png and .Jpeg formats.
                            </li>
                          </ul>
                          <ul>
                            <h6>Download Package</h6>
                            <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/icon-package/">
                              <i className="small material-icons">picture_as_pdf</i>
                            </a>
                          </ul>
                        </div>
                        <div className="landing-program">
                          <h5>Direct Messaging</h5>
                          <ul>
                            <h6>Statement Inserts</h6>
                            <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/statement-inserts/">
                              <i className="small material-icons">picture_as_pdf</i>
                            </a>
                          </ul>
                          <ul>
                            <h6>Statement Copy</h6>
                            <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/statement-content/">
                              <i className="small material-icons">picture_as_pdf</i>
                            </a>
                          </ul>
                        </div>
                      </div>
                      <div className="landing-program presentaion-materials">
                        <h5>Presentation Materials</h5>
                        <ul>
                          <h6>PowerPoint</h6>
                          <p>Clearly present settlement basics in 5 slides.</p>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/presentation-example/">
                            <i className="small material-icons">collections</i>
                          </a>
                        </ul>
                        <ul>
                          <h6>One Pager</h6>
                          <p>Present settlement basics on a single page</p>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.collectivelyapp.com/presentation-example/">
                            <i className="small material-icons">collections</i>
                          </a>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

RegistrationLinks.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  data: state.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllAffiliateLinkAction,
    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RegistrationLinks),
);
